// extracted by css-extract-rspack-plugin
export default {"card":"card-qXE_z_","header":"header-q_T0Tt","title":"title-rp8cqH"};